module.exports = __webpack_public_path__ + "img/tracking.dc73c4ad.svg";